<template>
  <Select
    :items="arrayStatus"
    :selectedItem="filter.status"
    :label="$i18n('interface.novo_filtro.status')"
    :searchPlaceholder="$i18n('interface.novo_filtro.buscar_status')"
    @atualizar="atualizar"
    :filtro_id="filtro.filtro"
    :path="path"
  />
</template>
<script>
import Select from '../../components/Select.vue';
export default {
  components: {
    Select,
  },
  props: {
    filtro: {
      type: Object,
      required: true,
    },
    path: {
      type: String,
      required: true
    },
    initialState: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      filter: {
        status: {
          id: "",
          name: "",
        },
      },
      arrayStatus: [
        { id: "vinculados", name: "Vinculados" },
        { id: "pendentes", name: "Pendentes" },
        { id: "nao_vinculados", name: "Não vinculados" },
      ],
    };
  },
  methods: {
    atualizar(status) {
      this.filter.status = status;

      this.$aplicaFiltroEmURL(this.filtro.filtro, this.filter.status.id, this.path);
      this.$store.commit('addFiltro', this.filtro);
      this.$store.commit('addFiltroAplicado', {
        filtro: this.filtro.filtro,
        valor: this.filter.status.id
      });
    },
  },
  mounted() {
    const filtroAplicado = this.$store.state.filtroAplicados[this.filtro.filtro];
    this.$renderFiltroSelect(filtroAplicado, this.arrayStatus, this.filter.status);
  },
}
</script>
